import client from "./client";

const getUserAffiliateData = (tokenId: number) => client.post("/getUserAffiliateData", {tokenId});

const getAchievementRewards = (tokenId: number) => client.post("/getAchievementRewards", {tokenId});

const affiliateWithDraw = (tokenId: number) => client.post("/affiliateWithDraw", {tokenId});

const getCommissionRewards = (tokenId: number) => client.post("/getCommissionRewards", {tokenId});

const getRefrralRewards = (tokenId: number) => client.post("/getRefrralRewards", {tokenId});

export const getBonusCodeRewards = (bonusCode: string) => client.post("/getBonusCodeRewards", {bonusCode});

export const getAggregationRewardData = (tokenId: number) => client.post("/getAggregationRewardData", {tokenId});

export const getBonusOrder = (type: number) => client.post("/getBonusOrder", {type});

const apiAffiliate = {
    getUserAffiliateData,
    getAchievementRewards,
    affiliateWithDraw,
    getCommissionRewards,
    getRefrralRewards,
    getBonusCodeRewards,
    getAggregationRewardData,
    getBonusOrder,
};

export default apiAffiliate;
